/**
 * The ways money moves between the company and an investor.
 *
 * Mirrors `PaymentMethods.All` on the server, which validates against the same list — keep the two
 * in step. Whitelisted rather than free text so the same method never ends up stored as
 * "jazzcash", "JazzCash" and "Jazz Cash" across three records.
 */
export const PAYMENT_METHODS = ['Cash', 'Bank', 'JazzCash', 'EasyPaisa'] as const;

export const paymentMethodOptions = PAYMENT_METHODS.map((m) => ({ value: m, label: m }));
